import React, { Fragment, useCallback } from 'react';
import { Col, Row, ListGroup, ListGroupItem, Button } from 'reactstrap';
import Strings from '../../../translations/Translations';
import MediaQuery from 'react-responsive';

export default function VideoReview(props) {
  const { remixPars, selectedStyle, selectedSong, parentSongType, changeStyleCallback, changeSongCallback, changeDetailsCallback } = props;

  const changeStyle = useCallback(() => {
    if (changeStyleCallback) {
      changeStyleCallback();
    }
  }, [changeStyleCallback]);

  const changeSong = useCallback(() => {
    if (changeSongCallback) {
      changeSongCallback();
    }
  }, [changeSongCallback]);

  const changeDetails = useCallback(() => {
    if (changeDetailsCallback) {
      changeDetailsCallback();
    }
  }, [changeDetailsCallback]);

  return (
    <Fragment>
      <Row>
        <Col md={12}>
          <p>
            <small><strong>{Strings('video_details')}</strong></small>
          </p>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          {remixPars.rti && (
            <ListGroup>
              <ListGroupItem>
                <div className='widget-content p-0'>
                  <div className='widget-content-wrapper'>
                    <div className='widget-content-left mr-3'>
                      {remixPars.rti && (
                        <h3 className='mb-0'>{remixPars.rti}</h3>
                      )}
                      {remixPars.rstag && (
                        <small>*{remixPars.rstag}</small>
                      )}
                      {remixPars.rde && (
                        <p className='mt-2' dangerouslySetInnerHTML={{ __html: remixPars.rde.replaceAll('\n', `<br />`) }}></p>
                      )}
                    </div>

                    <div className='widget-content-right'>
                      <Button
                        color='secondary'
                        outline
                        size='sm'
                        onClick={changeDetails}
                      >
                        {Strings('change')}
                      </Button>
                    </div>
                  </div>
                </div>
              </ListGroupItem>
            </ListGroup>
          )}
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          {selectedStyle && (
            <Fragment>
              {/* MOBILE VIEW */}
              <MediaQuery maxWidth={767}>
                <ListGroup className='mt-4'>
                  <ListGroupItem>
                    <Row>
                      <Col xs={6}>
                        <img
                          width={140}
                          className='rounded'
                          alt={selectedStyle.BaName}
                          src={selectedStyle.posterSrc}
                        />
                      </Col>
                      <Col xs={6}>
                        <div className=''>
                          <div className='badge badge-secondary'>
                            {Strings('selected_style')}
                          </div>
                        </div>
                        <div className='widget-heading'>
                          {selectedStyle.BaName}
                        </div>
                        <Button
                          color='secondary'
                          outline
                          size='sm'
                          onClick={changeStyle}
                        >
                          {Strings('change')}
                        </Button>
                      </Col>
                    </Row>
                  </ListGroupItem>
                </ListGroup>
              </MediaQuery>

              {/* DESKTOP VIEW */}
              <MediaQuery minWidth={768}>
                <ListGroup className='mt-4'>
                  <ListGroupItem>
                    <div className='widget-content p-0'>
                      <div className='widget-content-wrapper'>
                        <div className='widget-content-left mr-3'>
                          <img
                            width={140}
                            className='rounded'
                            alt={selectedStyle.BaName}
                            src={selectedStyle.posterSrc}
                          />
                        </div>
                        <div className='widget-content-left'>
                          <div className=''>
                            <div className='badge badge-secondary'>
                              {Strings('selected_style')}
                            </div>
                          </div>
                          <div className='widget-heading'>
                            {selectedStyle.BaName}
                          </div>
                        </div>
                        <div className='widget-content-right'>
                          <Button
                            color='secondary'
                            outline
                            size='sm'
                            onClick={changeStyle}
                          >
                            {Strings('change')}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </ListGroupItem>
                </ListGroup>
              </MediaQuery>


            </Fragment>
          )}
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          {selectedSong && (
            <ListGroup className='mt-4 mb-2 song-card'>
              <ListGroupItem>
                <div className='widget-content p-0'>
                  <div className='widget-content-wrapper'>
                    <div className='widget-content-left mr-3'>
                      {parentSongType && parentSongType !== 3 && (
                        <img
                          width={140}
                          className='rounded'
                          alt={selectedSong && selectedSong.name}
                          src={selectedSong && selectedSong.thumb}
                        />
                      )}
                    </div>
                    <div className='widget-content-left'>
                      <div className='widget-heading'>
                        <div>
                          <div className='badge badge-secondary mr-2'>{Strings('selected_song')}</div>
                          {selectedSong && selectedSong.type && selectedSong.type === 1 && <div className='badge badge-secondary'>{Strings('pepblast_song')}</div>}
                          {selectedSong && selectedSong.type && selectedSong.type === 2 && <div className='badge badge-secondary'>{Strings('apple_music')}</div>}
                        </div>
                        {selectedSong && selectedSong.name}
                      </div>
                      <div className='widget-subheading'>
                        {selectedSong && selectedSong.artist}
                      </div>
                      <div className='mt-2'>
                        {selectedSong && selectedSong.preview && (
                          <audio
                            controls
                            controlsList='nodownload'
                          >
                            <source type='audio/mp3' src={selectedSong.preview} />
                            {Strings('your_browser_does_not_support_html5')}
                          </audio>
                        )}

                      </div>
                    </div>
                    <div className='widget-content-right'>
                      <Button
                        color='secondary'
                        outline
                        size='sm'
                        onClick={changeSong}
                      >
                        {Strings('change')}
                      </Button>
                    </div>
                  </div>
                </div>
              </ListGroupItem>
            </ListGroup>
          )}
        </Col>
      </Row>
    </Fragment>
  );
}
